import React from 'react';
import CheckIcon from '@mui/icons-material/Check';
import { PASSWORD_RULES } from '../../utils/passwordPolicy';
import './PasswordRequirements.css';

const PasswordRequirements = ({ password, id }) => password.length > 0 ? (
  <div className="password-policy" id={id}>
    <ul className="password-policy-checklist" aria-label="Critères du mot de passe">
      {PASSWORD_RULES.map((rule) => {
        const isMet = rule.test(password);
        return (
          <li key={rule.id} className={isMet ? 'is-met' : 'is-unmet'}>
            <span className="password-policy-icon" aria-hidden="true">{isMet ? <CheckIcon /> : '○'}</span>
            <span>{rule.label}<span className="password-policy-sr-only">{isMet ? ' : critère rempli' : ' : critère non rempli'}</span></span>
          </li>
        );
      })}
    </ul>
  </div>
) : null;

export default PasswordRequirements;
